import UploadImg from './uploadImg.vue'
export default UploadImg
